const REQUIRED = ["title"];

export function validateClass(values) {
  const errors = {};

  REQUIRED.forEach(requiredField => {
    if (!values[requiredField]) {
      errors[requiredField] = ["ra.validation.required"];
    }
  });

  return errors;
}
